var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitiesNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10.6667,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_5427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3084 8.47119L19.3784 8.47786L9.53003 15.2062L9.5367 16.5862L19.3834 23.1912L20.3 23.1979L30.4534 16.5929L30.4584 15.1995L20.3084 8.47119ZM11.4867 15.8879L19.855 10.1712L28.4817 15.8879L19.855 21.5012L11.4867 15.8879ZM19.385 27.3579L9.65503 20.8329H12.6467L19.855 25.6662L27.2867 20.8329H30.3417L29.0084 21.6995C27.4934 21.5451 25.9712 21.9138 24.6947 22.7443C23.4183 23.5747 22.4644 24.8169 21.9917 26.2645L20.3034 27.3645L19.385 27.3579ZM21.6734 28.6512L19.8567 29.8345L12.645 24.9995H9.65503L19.385 31.5245L20.3017 31.5312L22.0017 30.4262C21.812 29.8522 21.7016 29.255 21.6734 28.6512ZM25.555 24.1762C26.1003 23.7924 26.7168 23.5216 27.3683 23.3797C28.0197 23.2377 28.693 23.2275 29.3485 23.3496C30.004 23.4717 30.6284 23.7237 31.1851 24.0907C31.7417 24.4577 32.2193 24.9324 32.5898 25.4867C32.9603 26.0411 33.2162 26.6639 33.3424 27.3186C33.4686 27.9733 33.4626 28.6467 33.3247 29.299C33.1868 29.9513 32.9199 30.5695 32.5395 31.1172C32.1592 31.6648 31.6732 32.1308 31.11 32.4879C30.0077 33.1867 28.6758 33.4268 27.3988 33.1569C26.1218 32.887 25.001 32.1285 24.2757 31.0433C23.5505 29.9582 23.2783 28.6324 23.5174 27.3493C23.7564 26.0662 24.4877 24.9274 25.555 24.1762ZM28.385 30.5379L31.3684 26.5595L30.035 25.5595L27.5684 28.8495L26.1084 27.6829L25.0684 28.9829L27.1984 30.6879L28.385 30.5379Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_5427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(6.66663 6.6665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesNav);
export default __webpack_public_path__ + "static/media/activities-nav.5f8ca8440e2a93dfd50e71b8b76d5535.svg";
export { ForwardRef as ReactComponent };